import Symbol from "./Symbol";
import SymbolAnim from "./SymbolAnim";
import {pixiSetTimeout} from "../../framework/src/engine/pixi/pixiTimeout";

export default class SymbolSeven extends Symbol{
    constructor(commander, speed) {
        super(commander, speed);
    }

    init() {
        this.texture = PIXI.Texture.from("symbol_Seven_particle.png");
        this.length = 1050;
    }

    animate(symbol, loop) {
        this.hideSymbol(symbol);
        return new Promise (res => {
            this.start(symbol).then((values) => { // duration - 1050ms
                let bg = values[0];
                let flares = values[1];
                let shine = values[2];
                this.loopShine(loop, shine).then((shine) => { // duration - 500ms * i
                    this.hideBg(bg, flares);
                    this.end(symbol, shine).then(() => res()); // duration - 250ms
                });
            })
        }).then(() => {
            this.clearEmitters();
        });
    }

    start(symbol) {
        return new Promise (res => {
            let promises = [];
            promises.push(this.background(symbol));
            promises.push(this.flares(symbol));
            promises.push(this.startShine(symbol));
            promises.push(this.startParticles(symbol));
            Promise.all(promises).then((values) => {
                res(values);
            });
        });
    }

    startShine(symbol) {
        return new Promise(res => {
            let shine = SymbolAnim.createSprite(symbol.x, symbol.y, "symbol_Seven.png");
            this.layer.addChild(shine);

            createjs.Tween.get(shine.scale)
                .to({x: 0.95, y: 0.95}, 200 * this.speed, createjs.Ease.linear)
                .to({x: 1.05, y: 1.05}, 200 * this.speed, createjs.Ease.linear)
                .to({x: 1.05, y: 1.05}, 300 * this.speed, createjs.Ease.quadOut)
                .to({x: 1.025, y: 1.025}, 400 * this.speed, createjs.Ease.linear)
                .to({x: 1.05, y: 1.05}, 300 * this.speed, createjs.Ease.quadOut)
                .call(() => {
                    SymbolAnim.removeTween(shine.scale);
                    res(shine);
                });
        });
    }

    loopShine(i,shine) {
        return new Promise(res => {
            if (i === 0) {
                res(shine);
            } else {
                createjs.Tween.get(shine.scale,{loop: true})
                    .to({x: 1.025, y: 1.025}, 300 * this.speed, createjs.Ease.linear)
                    .to({x: 1.05, y: 1.05}, 200 * this.speed, createjs.Ease.quadOut)
                    .call(() => {
                        if (--i < 1) {
                            SymbolAnim.removeTween(shine.scale);
                            res(shine);
                        }
                    });

            }
        })
    }

    background(symbol) {
        return new Promise(res => {
            let bg = SymbolAnim.createSprite(symbol.x, symbol.y, "symbol_Seven_background.png");
            bg.alpha = 0;
            this.layer.addChild(bg);

            createjs.Tween.get(bg)
                .wait(50*this.speed)
                .to({alpha: 1}, 150*this.speed, createjs.Ease.quadOut)
                .call(() => {SymbolAnim.removeTween(bg)});

            pixiSetTimeout((this.length / 1000) * this.speed, () => {
                res(bg);
            });
        })
    }

    flares(symbol) {
        return new Promise(res => {
            let flares = SymbolAnim.createSprite(symbol.x, symbol.y, "symbol_Seven_flares.png", {x: 0.5, y: 0.48});
            flares.alpha = 0;

            this.layer.addChild(flares);
            createjs.Tween.get(flares)
                .wait(50 * this.speed)
                .to({alpha: 1}, 50 * this.speed, createjs.Ease.quadOut);

            createjs.Tween.get(flares, {loop: true})
                .to({rotation: 10*3.14}, 10*1000* this.speed, createjs.Ease.linear);

            pixiSetTimeout((this.length / 1000) * this.speed, () => {
                res(flares);
            });
        });
    }

    // dlzka 830ms
    startParticles(symbol) {
        return new Promise(res => {
            let pt = [
                {x: symbol.x, y: symbol.y+50},
                {x: symbol.x+50, y: symbol.y-50},
                {x: symbol.x-50, y: symbol.y-50}
            ];
            createjs.Tween.get()
                .wait(1200*this.speed)
                .call(() => {
                    this.createSpark(pt[0].x, pt[0].y);
                    SymbolAnim.runEmitter(this.createSmallEmitter(pt[0].x, pt[0].y));
                })
                .wait(300*this.speed)
                .call(() => {
                    this.createSpark(pt[1].x, pt[1].y);
                    SymbolAnim.runEmitter(this.createSmallEmitter(pt[1].x, pt[1].y));
                })
                .wait(300*this.speed)
                .call(() => {
                    this.createSpark(pt[2].x, pt[2].y);
                    SymbolAnim.runEmitter(this.createSmallEmitter(pt[2].x, pt[2].y));
                })
                .call(() => {
                    res();
                });
        })
    }

    end(symbol, shine) {
        return new Promise (res => {
            this.endShine(shine, symbol, res);
        });
    }

    endShine (shine, symbol, callback = () => {}) {
        createjs.Tween.get(shine)
            .wait(350* this.speed)
            .call(() => {
                this.showSymbol(symbol);
            })
            .to({alpha: 0}, 100 * this.speed, createjs.Ease.quadOut)
            .call(() => {
                SymbolAnim.removeTween(shine);
            });
        SymbolAnim.removeTween(shine.scale);
        createjs.Tween.get(shine.scale)
            .to({x: 0.95, y: 0.95}, 100 * this.speed, createjs.Ease.quadOut)
            .to({x: 1, y: 1}, 350 * this.speed, createjs.Ease.quadOut)
            .call(() => {
                SymbolAnim.removeTween(shine.scale);
                callback();
            });
    }

    hideBg(bg, flares) {
        createjs.Tween.get(bg)
            .wait(150*this.speed)
            .to({alpha: 0}, 150 *this.speed, createjs.Ease.linear)
            .call(() => {
                SymbolAnim.removeTween(bg);
            });
        createjs.Tween.get(flares)
            .wait(150*this.speed)
            .to({alpha: 0}, 150 *this.speed, createjs.Ease.linear)
            .call(() => {
                SymbolAnim.removeTween(flares);
            });
    }
}